/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventTicket,
    JsonEventTicketFromJSON,
    JsonEventTicketFromJSONTyped,
    JsonEventTicketToJSON,
} from './JsonEventTicket';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventTicket
 */
export interface ApiResultOfJsonEventTicket {
    /**
     * 
     * @type {JsonEventTicket}
     * @memberof ApiResultOfJsonEventTicket
     */
    data?: JsonEventTicket;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventTicket
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventTicket
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventTicket
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventTicket
     */
    result?: ApiResultOfJsonEventTicketResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventTicketResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventTicketFromJSON(json: any): ApiResultOfJsonEventTicket {
    return ApiResultOfJsonEventTicketFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventTicketFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventTicket {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventTicketFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventTicketToJSON(value?: ApiResultOfJsonEventTicket | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventTicketToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

